import {IResponse} from '../../common/model/Core.model'
import {environment} from '../../util/Environment'
import {apiSlice} from '../store/Api'
import {IAssetCreateRequestDto, IAssetDto, IAssetSearchRequestDto, IAssetUpdateRequestDto} from './Asset.model'

export const assetApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      assetFamilyGetAll: builder.mutation<IResponse, void>({
        query() {
          return {
            url: `${environment.apiUrl.asset}/family`,
            method: 'GET',
          }
        },
      }),
      assetAreaGetAll: builder.mutation<IResponse, void>({
        query() {
          return {
            url: `${environment.apiUrl.asset}/area`,
            method: 'GET',
          }
        },
      }),
      assetSearch: builder.mutation<IResponse, IAssetSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.asset}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      assetLoadMore: builder.mutation<IResponse, IAssetSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.asset}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      assetGetById: builder.mutation<IAssetDto, {id: string, fields?: string}>({
        query(parameters) {
          return {
            url: parameters.fields 
              ? `${environment.apiUrl.asset}/${parameters.id}?fields=${parameters.fields}`
              : `${environment.apiUrl.asset}/${parameters.id}`,
            method: 'GET',
          }
        },
      }),
      assetUpdateById: builder.mutation<IAssetDto, IAssetUpdateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.asset}/${body.id}`,
            method: 'PATCH',
            body,
          }
        },
      }),
      assetDeleteById: builder.mutation<IAssetDto, string>({
        query(id) {
          return {
            url: `${environment.apiUrl.asset}/${id}`,
            method: 'DELETE',
          }
        },
      }),
      assetCreate: builder.mutation<IAssetDto, IAssetCreateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.asset}`,
            method: 'POST',
            body,
          }
        },
      }),
    }
  },
})

export const { 
  useAssetFamilyGetAllMutation, 
  useAssetAreaGetAllMutation, 
  useAssetSearchMutation, 
  useAssetLoadMoreMutation, 
  useAssetGetByIdMutation, 
  useAssetUpdateByIdMutation, 
  useAssetDeleteByIdMutation, 
  useAssetCreateMutation
} = assetApi
